import React from 'react';
import { Redirect } from 'react-router-dom';
import { ROLE } from './constants';

// Layout Types
import { IconSidebar } from './layouts';

// Route Views
import Login from './views/Login';
import ForgotPassword from './views/ForgotPassword';
import VerifyCode from './views/VerifyCode';
import News from './views/News';
import MillSheetSearch from './views/MillSheetSearch';
import UserInfo from './views/UserInfo';
import ManageApproval from './views/ManageApproval';
import ManageOrganizationBase from './views/ManageOrganizationBase';
import ManageOrganization from './views/ManageOrganization';
import ManageCondition from './views/ManageCondition';
import ManageUser from './views/ManageUser';
import ManageDeliveryLocation from './views/ManageDeliveryLocation';
import ManageInformation from './views/ManageInformation';
import ManageNews from './views/ManageNews';
import InventoryStatus from './views/InventoryStatus';
import InventoryJob from './views/InventoryJob';
import ConfirmContinuation from './views/ConfirmContinuation';
import QA from './views/QA';
import Download from './views/Download';
import EnvBorder from './components/layout/EnvBorder';

const BlankLayout = ({ children }) => (
  <>
    <EnvBorder />
    {children}
  </>
);
const redirectToLogin = () => <Redirect to="/login" />;

export default [
  // ログイン関連ページ
  // ========================================
  {
    path: '/',
    exact: true,
    layout: BlankLayout,
    component: redirectToLogin,
  },
  {
    path: '/login',
    exact: false,
    layout: BlankLayout,
    component: Login,
  },
  {
    path: '/forgot-password',
    exact: false,
    layout: BlankLayout,
    component: ForgotPassword,
  },
  {
    path: '/verify-code',
    exact: false,
    layout: BlankLayout,
    component: VerifyCode,
  },

  // 基本ページ
  // ========================================
  {
    path: '/mill-sheet-search',
    exact: false,
    layout: IconSidebar,
    component: MillSheetSearch,
    accessibleRoles: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN],
  },
  {
    path: '/news',
    exact: false,
    layout: IconSidebar,
    component: News,
    accessibleRoles: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN],
  },
  {
    path: '/user-info',
    exact: false,
    layout: IconSidebar,
    component: UserInfo,
    accessibleRoles: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    path: '/download',
    exact: false,
    layout: IconSidebar,
    component: Download,
    accessibleRoles: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    path: '/qa',
    exact: false,
    layout: IconSidebar,
    component: QA,
    accessibleRoles: [ROLE.USER, ROLE.POWERUSER, ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    path: '/manage-approval',
    exact: false,
    layout: IconSidebar,
    component: ManageApproval,
    accessibleRoles: [ROLE.ADMIN],
  },
  {
    path: '/manage-organization-base',
    exact: false,
    layout: IconSidebar,
    component: ManageOrganizationBase,
    accessibleRoles: [ROLE.MAINTENANCE_ADMIN],
  },
  {
    path: '/manage-organization',
    exact: false,
    layout: IconSidebar,
    component: ManageOrganization,
    accessibleRoles: [ROLE.ADMIN],
  },
  {
    path: '/manage-condition',
    exact: false,
    layout: IconSidebar,
    component: ManageCondition,
    accessibleRoles: [ROLE.POWERUSER, ROLE.ADMIN],
  },
  {
    path: '/manage-user',
    exact: false,
    layout: IconSidebar,
    component: ManageUser,
    accessibleRoles: [ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    path: '/manage-delivery-location',
    exact: false,
    layout: IconSidebar,
    component: ManageDeliveryLocation,
    accessibleRoles: [ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    path: '/manage-information',
    exact: false,
    layout: IconSidebar,
    component: ManageInformation,
    accessibleRoles: [ROLE.MAINTENANCE_ADMIN],
  },
  {
    path: '/manage-news',
    exact: false,
    layout: IconSidebar,
    component: ManageNews,
    accessibleRoles: [ROLE.ADMIN],
  },

  // 棚卸関連ページ
  // ========================================
  {
    path: '/inventory-job',
    exact: false,
    layout: IconSidebar,
    component: InventoryJob,
    accessibleRoles: [ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    path: '/inventory-status',
    exact: false,
    layout: IconSidebar,
    component: InventoryStatus,
    accessibleRoles: [ROLE.ADMIN, ROLE.MAINTENANCE_ADMIN],
  },
  {
    path: '/confirm-continuation',
    exact: false,
    layout: BlankLayout,
    component: ConfirmContinuation,
  },
];
